import React, { useEffect, useState } from "react";
import axios from "axios";
import { Formik, Field } from "formik";
import { Form } from "react-bootstrap";
import { validationSchemaDatosAfiliados } from "../../utils/validationSchemaForm";
import MaskedInput from "react-text-mask";
import { removeCodigoArea, cleanDigitos } from "../../utils/cleanInputMask";
import { convertDate } from "../../utils/date";
import { fechaMask } from "../../utils/inputMask";
import { oacento, uacento } from "../../utils/caracteresUTF8";
import ConfigurationManager from "../../settings/ConfigurationManager";
import { Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { obtenerComunas } from "../../services/api/comuna/index";
import { obtenerInstituciones } from "../../services/api/institucionSalud/index";
import { obtenerCondicionLaboral } from "../../services/api/condicionLaboral";
import { obtenerParametrosReposo } from "../../services/api/reposo";
import PreDataFormAfiliados from "../FormPreData/formAfiliados";
import { initialValuesFormAfiliados } from "../../utils/initialValues/formAfiliados";
import { obtenerOcupacionuOficio } from "../../services/api/ocupacion";
import { obtenerNivelEducacional } from "../../services/api/nivelEducacional";
import { obtenerTipoAfiliadoPensionado } from "../../services/api/tipoAfiliado";
import { genericPost } from "../../utils/genericApiCall";
import Stack from "../commons/stack/Stack";

const FormDatosAfiliados = () => {
  let history = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [regiones, setRegiones] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [comunas, setComunas] = useState([]);
  const [regionesReposo, setRegionesReposo] = useState([]);
  const [ciudadesReposo, setCiudadesReposo] = useState([]);
  const [comunasReposo, setComunasReposo] = useState([]);
  const [previsiones, setPrevisiones] = useState([]);
  const [region, setRegion] = useState("99");
  const [ciudad, setCiudad] = useState("");
  const [comuna, setComuna] = useState("");
  const [regionReposo, setRegionReposo] = useState("");
  const [ciudadReposo, setCiudadReposo] = useState("");
  const [esBeneficiario, setEsBeneficiario] = useState("");
  const [TipoAfiliado, setTipoAfiliado] = useState();
  const [comunaReposo, setComunaReposo] = useState(false);
  const [condicionesLaborales, setCondicionesLaborales] = useState([]);
  const [parametrosReposo, setParametrosReposo] = useState([]);
  const [parametrosOcupacion, setParametrosOcupacion] = useState([]);
  const [parametrosEducacion, setParametrosEducacion] = useState([]);
  const [parametrosAfiliadoPensionado, setParametrosAfiliadoPensionado] = useState([]);

  const [loadingCiudades, setLoadingCiudades] = useState(false);
  const [loadingComunas, setLoadingComunas] = useState(false);

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  async function selectComuna(event, formik) {
    let selected = event.target.value;
    formik.setFieldValue("comuna", selected);
    setComuna(selected);
  }

  async function selectComunaReposo(event, formik) {
    let selected = event.target.value;
    formik.setFieldValue("comunaReposo", selected);
    setComunaReposo(selected);
  }

  async function selectCiudad(event, formik) {
    try {
      setLoadingComunas(true);

      var value = event.target.value;

      formik.setFieldValue("ciudad", value);
      setCiudad(value);

      formik.setFieldValue("comuna", "99");
      setComunas([]);

      if (value !== "99" || value !== "Seleccionar" || value !== "") {
        var data = value.split("-");
        let json = await ciudades.find((x) => x.codigo === data[0]);

        if (json !== undefined) {
          setComunas(json["comunas"]);
        }
      }
      await delay(1000);
    } finally {
      setLoadingComunas(false);
    }
  }

  async function selectCiudadReposo(event, formik) {
    var value = event.target.value;

    formik.setFieldValue("ciudadReposo", value);
    setCiudadReposo(value);

    formik.setFieldValue("comunaReposo", "99");
    setComunasReposo([]);

    if (value !== "99" || value !== "Seleccionar" || value !== "") {
      var data = value.split("-");
      let json = await ciudadesReposo.find((x) => x.codigo === data[0]);

      if (json !== undefined) {
        setComunasReposo(json["comunas"]);
      }
    }
  }

  async function selectRegion(event, formik) {
    try {
      setLoadingCiudades(true);
      setLoadingComunas(true);
      let selected = event.target.value;

      formik.setFieldValue("region", selected);
      setRegion(selected);

      formik.setFieldValue("ciudad", "99");
      setCiudades([]);

      formik.setFieldValue("comuna", "99");
      setComunas([]);

      if (selected !== "99" || selected !== "") {
        let json = await regiones.find((x) => x.codigo === selected);

        if (json !== undefined) {
          setCiudades(json["provincias"]);
        }
      }
      await delay(1000);
    } finally {
      setLoadingCiudades(false);
      setLoadingComunas(false);
    }
  }

  async function selectRegionReposo(event, formik) {
    let selected = event.target.value;

    formik.setFieldValue("regionReposo", selected);
    setRegionReposo(selected);

    formik.setFieldValue("ciudadReposo", "99");
    setCiudadesReposo([]);

    formik.setFieldValue("comunaReposo", "99");
    setComunasReposo([]);

    if (selected !== "99" || selected !== "") {
      let json = await regiones.find((x) => x.codigo === selected);

      if (json !== undefined) {
        setCiudadesReposo(json["provincias"]);
      }
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          comunasResponse,
          institucionesSaludResponse,
          condicionesLaboralesResponse,
          parametrosReposoResponse,
          parametrosOcupacionesResponse,
          parametrosEducacionResponse,
          parametrosAfiliadoPensionadoResponse,
        ] = await Promise.all([
          obtenerComunas(),
          obtenerInstituciones(),
          obtenerCondicionLaboral(),
          obtenerParametrosReposo(),
          obtenerOcupacionuOficio(),
          obtenerNivelEducacional(),
          obtenerTipoAfiliadoPensionado(),
        ]);

        if (comunasResponse.status === 200) {
          setRegiones(comunasResponse.data);
          setRegionesReposo(comunasResponse.data);
        }

        if (institucionesSaludResponse.status === 200) {
          const data = institucionesSaludResponse.data;

          if (data.ok) {
            const previ = data.resultado.map((datos) => ({
              codigo: datos.idInstSalud,
              nombre: datos.descripcion,
            }));
            setPrevisiones(previ);
          }
        }

        if (condicionesLaboralesResponse.status === 200) {
          setCondicionesLaborales(condicionesLaboralesResponse.data.resultado);
        }

        if (parametrosReposoResponse.status === 200) {
          setParametrosReposo(parametrosReposoResponse.data);
        }

        if (parametrosOcupacionesResponse.status === 200) {
          setParametrosOcupacion(parametrosOcupacionesResponse.data.resultado);
        }

        if (parametrosEducacionResponse.status === 200) {
          setParametrosEducacion(parametrosEducacionResponse.data);
        }

        if (parametrosAfiliadoPensionadoResponse.status === 200) {
          setParametrosAfiliadoPensionado(
            parametrosAfiliadoPensionadoResponse.data
          );
        }
        setTipoAfiliado(localStorage.getItem("informante"));
        setEsBeneficiario(
          localStorage.getItem("esBeneficiario") === "true" ? "Si" : "No"
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = (e, values) => {
    e.preventDefault();

    setIsLoading(true);

    try {

      let nuevaFecha = convertDate(values.fechaNacimiento);

      axios
        .get(`${ConfigurationManager.API_URL}/Solicitud/obtenerSolicitud?rut=${localStorage.getItem("idPersona")}`,
          { headers: ConfigurationManager.JSON_HEADER }
        )
        .then((response) => {
          let data = response.data;

          if (response.status === 200) {
            let body = data.resultado;

            body.CodEstado = 10;
            body.nombreAfi = values.nombres;
            body.apPaternoAfi = values.apellidoPaterno;
            body.apMaternoAfi = values.apellidoMaterno;
            body.fecNacAfi = nuevaFecha;
            body.generoAfi = values.genero;
            body.nombreCalleAfi = values.direccion;
            body.numeroAfi = values.numero;
            body.numeroDeptoAfi = values.depto;
            body.poblacionVillaAfi = values.villa;
            body.codRegionAfi = region;

            var newCiudad = ciudad.split("-");
            body.ciudadAfi = newCiudad[1];
            body.codComunaAfi = comuna;

            body.celularAfiPrincipal = removeCodigoArea(
              cleanDigitos(values.telefonoPrincipal)
            );
            body.celularAfiOpcional = removeCodigoArea(
              cleanDigitos(values.telefonoSecundario)
            );

            body.emailAfi = values.correo;
            body.codInstitucionSalud = parseInt(values.prevision);
            body.indAutorizaSusCalificacion = "S"; // 20211130 MODELO INDICA QUE SIEMPRE DEBE IR EN 'S' values.calificacionInvalidez ? "S" : "N";

            let body_anexo = {};

            body_anexo.idNumeroFolio = data.resultado.folioSolicitud;
            body_anexo.idTipAfiPen = parseInt(values.afiliadoPensionado);
            body_anexo.idRepPen = parseInt(values.lugarReposo);
            body_anexo.idConAfi = parseInt(values.antecedentesLaborales);
            body_anexo.idNivEduAfi = parseInt(values.nivelEducacional);
            body_anexo.idProOfiAfi = parseInt(values.profesion);
            body_anexo.calle = values.direccionReposo;
            body_anexo.numero = values.numeroReposo;
            body_anexo.departamentoCasa = values.deptoReposo;
            body_anexo.villaPoblacion = values.villaReposo;
            body_anexo.codRegion = parseInt(values.regionReposo);

            var newCiudadReposo = values.ciudadReposo.split("-");
            body_anexo.ciudad = newCiudadReposo[1];
            body_anexo.codComuna = parseInt(values.comunaReposo);
            body_anexo.nombreRecintoHospilatario = values.recintoHospitalario;
            body_anexo.fecIniDes = convertDate(
              values.fechaInicioDesempleoPrivado
            );
            body_anexo.fecCeseFunciones = convertDate(
              values.fechaInicioDesempleoPublico
            );
            body_anexo.fecIniLicMed = convertDate(
              values.fechaInicioLicenciaMedica
            );
            body_anexo.fecTerLicMed = convertDate(values.fechaFinLicenciaMedica);

            let bodyAutoriza = {
              folioSolicitud: data.resultado.folioSolicitud,
              idPersona: localStorage.getItem("idPersona"),
              respuesta: values.Autoriza ? "Si" : "No",
              tipoInformante: TipoAfiliado,
              beneficiario: esBeneficiario,
              cobertura: values.radioCobertura,
            };

            genericPost({
              url_endpoint: "/Solicitud/autorizaBenficiario",
              body: bodyAutoriza,
              message_info: "Datos autorización",
              message_error: "error al grabar autorización",
            });

            axios
              .put(
                `${ConfigurationManager.API_URL}/Solicitud/actualizarSolicitud`,
                body,
                { headers: ConfigurationManager.JSON_HEADER }
              )
              .then((response) => {
                let data = response.data;

                if (response.status === 200) {
                  if (data.ok) {
                    axios
                      .get(
                        `${ConfigurationManager.API_URL}/OpAfiliadosAnexo/ObtenerAnexoRetiroAfiliadoPorFolio?idFolio=${body_anexo.idNumeroFolio}`
                      )
                      .then((response) => {
                        if (
                          response.status === 200 &&
                          response.data.ok === false
                        ) {
                          axios
                            .post(
                              `${ConfigurationManager.API_URL}/OpAfiliadosAnexo/IngresarDatosRetiroAfiliadoAnexo`,
                              body_anexo,
                              { headers: ConfigurationManager.JSON_HEADER }
                            )
                            .then((response) => {
                              if (response.status === 200 && response.data.ok) {
                                history("/paet/documentos");
                              }
                            })
                            .catch((e) => {
                              console.error(
                                "/OpAfiliadosAnexo/IngresarDatosRetiroAfiliadoAnexo: ",
                                e
                              );
                            });
                        }

                        if (response.status === 200 && response.data.ok) {
                          axios
                            .put(
                              `${ConfigurationManager.API_URL}/OpAfiliadosAnexo/ActualizarDatosRetiroAfiliadoAnexo`,
                              body_anexo,
                              { headers: ConfigurationManager.JSON_HEADER }
                            )
                            .then((response) => {
                              if (response.status === 200 && response.data.ok) {
                                history("/paet/documentos");
                              }
                            })
                            .catch((e) => {
                              console.error(
                                "/OpAfiliadosAnexo/ActualizarDatosRetiroAfiliadoAnexo: ",
                                e
                              );
                            });
                        }
                      });
                  }
                }
              })
              .catch((e) => {
                console.error("/Solicitud/actualizarSolicitud: ", e);
              });
          }
        })
        .catch((e) => {
          console.error("Servicio Solicitud: ", e);
        });
    } catch (error) {

    } finally {
      delay(2000);
      setIsLoading(false);
    }
  };

  return (
    <Formik
      initialValues={initialValuesFormAfiliados}
      validationSchema={validationSchemaDatosAfiliados}
    >
      {(formik) => (
        <Form>
          <PreDataFormAfiliados />

          <Field name="nombres">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="nombres">
                <p className="mb-2 fs-5 fw-bold border-bottom pb-2">
                  Información Personal
                </p>
                <Form.Label>Nombres</Form.Label>
                <Form.Control
                  {...field}
                  className="form-control-lg"
                  type="text"
                  placeholder=""
                  autoComplete="off"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="nombresAyuda"
                />
                <Form.Control.Feedback type={"invalid"} id="nombresAyuda">
                  {meta.error ? meta.error : "Indícanos tu nombre o si tienes más de uno. Ej: Ana Antonia."}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="apellidoPaterno">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="apellidoPaterno">
                <Form.Label>Apellido Paterno</Form.Label>
                <Form.Control
                  {...field}
                  className="form-control-lg"
                  type="text"
                  placeholder=""
                  autoComplete="off"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="apellidoPaternoAyuda"
                />
                <Form.Control.Feedback type={"invalid"}>
                  {meta.error ? meta.error : "Indícanos tu apellido paterno. Ej: Soto."}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="apellidoMaterno">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="apellidoMaterno">
                <Form.Label>Apellido Materno (opcional)</Form.Label>
                <Form.Control
                  {...field}
                  className="form-control-lg"
                  type="text"
                  placeholder=""
                  autoComplete="off"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="apellidoMaternoAyuda"
                />
                <Form.Control.Feedback type={"invalid"}>
                  {meta.error ? meta.error : "Indícanos tu apellido materno. Ej: Modelo."}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="fechaNacimiento">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="fechaNacimiento">
                <Form.Label>Fecha de nacimiento</Form.Label>
                <Form.Control
                  {...field}
                  mask={fechaMask}
                  type="text"
                  className="form-control-lg"
                  placeholder="dd/mm/yyyy"
                  autoComplete="off"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="fechaNacimientoAyuda"
                />
                <Form.Control.Feedback type={"invalid"}>
                  {meta.error ? meta.error : "Ej: 01/12/1991."}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="genero">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="genero">
                <Form.Label>Indique su género</Form.Label>
                <Form.Control
                  {...field}
                  as="select"
                  className="form-control-lg"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="generoAyuda"
                >
                  <option value="99">Seleccionar</option>
                  <option value="F">Femenino</option>
                  <option value="M">Masculino</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : ""}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="direccion">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="direccion">
                <Form.Label>Dirección</Form.Label>
                <Form.Control
                  {...field}
                  type="text"
                  className="form-control-lg"
                  placeholder=""
                  autoComplete="off"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="direccionAyuda"
                />
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : "Ej: Avenida Modelo"}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="numero">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="numero">
                <Form.Label>Número</Form.Label>
                <Form.Control
                  {...field}
                  type="text"
                  className="form-control-lg"
                  placeholder=""
                  autoComplete="off"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="numeroAyuda"
                />
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : "Ej: #2021"}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="depto">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="depto">
                <Form.Label>N° de departamento / Casa (opcional)</Form.Label>
                <Form.Control
                  {...field}
                  type="text"
                  className="form-control-lg"
                  placeholder=""
                  autoComplete="off"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="deptoAyuda"
                />
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : "Ej: B22"}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="villa">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="villa">
                <Form.Label>Villa o Población (opcional)</Form.Label>
                <Form.Control
                  {...field}
                  type="text"
                  className="form-control-lg"
                  placeholder=""
                  autoComplete="off"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="villaAyuda"
                />
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : "Ej: Villa el Porvenir."}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="region">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="region">
                <Form.Label>Región</Form.Label>
                <Form.Control
                  {...field}
                  as="select"
                  className="form-control-lg"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  value={field.value}
                  onChange={(e) => {
                    field.onChange(e);  // Se asegura de manejar correctamente el cambio
                    selectRegion(e, formik); // Asumiendo que `selectRegion` es una función externa                    
                  }}
                  aria-describedby="regionAyuda"
                >
                  <option value="99">Seleccionar</option>
                  {regiones.map((datos) => (
                    <option key={datos.codigo} value={datos.codigo}>
                      {datos.region}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : ""}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="ciudad">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="ciudad">
                <Form.Label>Ciudad</Form.Label>
                <Form.Control
                  {...field}
                  as="select"
                  disabled={loadingCiudades}
                  className="form-control-lg"
                  value={field.value}
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  onChange={(e) => {
                    field.onChange(e);  // Integrar con Formik
                    selectCiudad(e, formik);  // Función personalizada externa
                  }}
                  aria-describedby="ciudadAyuda"
                >
                  <option value="99">{loadingCiudades ? "Cargando..." : "Seleccionar"}</option>
                  {!loadingCiudades && ciudades.map((datos) => (
                    <option key={`${datos.codigo}-${datos.provincia}`} value={`${datos.codigo}-${datos.provincia}`}>
                      {datos.provincia}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : ""}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="comuna">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="comuna">
                <Form.Label>Comuna</Form.Label>
                <Form.Control
                  {...field}
                  as="select"
                  disabled={loadingComunas}
                  className="form-control-lg"
                  value={field.value}
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  onChange={(e) => {
                    field.onChange(e);  // Integrar con Formik
                    selectComuna(e, formik);  // Función personalizada externa
                  }}
                  aria-describedby="comunaAyuda"
                >
                  <option value="99">{loadingComunas ? "Cargando..." : "Seleccionar"}</option>
                  {!loadingComunas && comunas.map((datos) => (
                    <option key={datos.codigo} value={datos.codigo}>
                      {datos.comuna}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : ""}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="lugarReposo">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="lugarReposo">
                <p className="mt-4 mb-2 fs-5 fw-bold border-bottom pb-2">
                  Lugar donde cumple reposo
                </p>
                <Form.Label>Indique donde cumple reposo actualmente:</Form.Label>
                <Form.Control
                  {...field}
                  as="select"
                  className="form-control-lg"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="lugarReposoAyuda"
                >
                  <option value="99">Seleccionar</option>
                  {parametrosReposo.map((datos) => (
                    <option key={datos.idRepPen} value={datos.idRepPen}>
                      {datos.descripcion}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : ""}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          {formik.values.lugarReposo === "2" && (
            <Field name="recintoHospitalario">
              {({ field, meta }) => (
                <Form.Group className="mb-3 input-wrapper" controlId="recintoHospitalario">
                  <Form.Label>Ej: Hospital Barros Luco</Form.Label>
                  <Form.Control
                    {...field}
                    type="text"
                    className="form-control-lg"
                    isInvalid={meta.error}
                    isValid={!meta.error}
                    placeholder=""
                    autoComplete="off"
                    aria-describedby="recintoHospitalarioAyuda"
                  />
                  <Form.Control.Feedback type="invalid">
                    {meta.error ? meta.error : "Ej: Hospital Barros Luco"}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            </Field>
          )}

          {formik.values.lugarReposo === "3" && (
            <>
              <Field name="direccionReposo">
                {({ field, meta }) => (
                  <Form.Group className="mb-3 input-wrapper" controlId="direccionReposo">
                    <Form.Label>Dirección</Form.Label>
                    <Form.Control
                      {...field}
                      type="text"
                      className="form-control-lg"
                      autoComplete="off"
                      isInvalid={meta.error}
                      isValid={!meta.error}
                      aria-describedby="direccionReposoAyuda"
                    />
                    <Form.Control.Feedback type="invalid">
                      {meta.error ? meta.error : "Ej: Avenida Modelo"}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Field>

              <Field name="numeroReposo">
                {({ field, meta }) => (
                  <Form.Group className="mb-3 input-wrapper" controlId="numeroReposo">
                    <Form.Label>Número</Form.Label>
                    <Form.Control
                      {...field}
                      type="text"
                      className="form-control-lg"
                      autoComplete="off"
                      isInvalid={meta.error}
                      isValid={!meta.error}
                      aria-describedby="numeroReposoAyuda"
                    />
                    <Form.Control.Feedback type="invalid">
                      {meta.error ? meta.error : "Ej: #2021"}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Field>

              <Field name="deptoReposo">
                {({ field, meta }) => (
                  <Form.Group className="mb-3 input-wrapper" controlId="deptoReposo">
                    <Form.Label>N° de departamento / Casa (opcional)</Form.Label>
                    <Form.Control
                      {...field}
                      type="text"
                      className="form-control-lg"
                      autoComplete="off"
                      isInvalid={meta.error}
                      isValid={!meta.error}
                      aria-describedby="deptoReposoAyuda"
                    />
                    <Form.Control.Feedback type="invalid">
                      {meta.error ? meta.error : "Ej: B22"}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Field>

              <Field name="villaReposo">
                {({ field, meta }) => (
                  <Form.Group className="mb-3 input-wrapper" controlId="villaReposo">
                    <Form.Label>Villa o Población (opcional)</Form.Label>
                    <Form.Control
                      {...field}
                      type="text"
                      className="form-control-lg"
                      autoComplete="off"
                      isInvalid={meta.error}
                      isValid={!meta.error}
                      aria-describedby="villaReposoAyuda"
                    />
                    <Form.Control.Feedback type="invalid">
                      {meta.error ? meta.error : "Ej: Villa el Porvenir"}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Field>

              <Field name="regionReposo">
                {({ field, meta }) => (
                  <Form.Group className="mb-3 input-wrapper" controlId="regionReposo">
                    <Form.Label>Región</Form.Label>
                    <Form.Control
                      {...field}
                      as="select"
                      className="form-control-lg"
                      value={field.value}
                      isInvalid={meta.error}
                      isValid={!meta.error}
                      onChange={(e) => {
                        field.onChange(e);
                        selectRegionReposo(e, formik);
                      }}
                      aria-describedby="regionReposoAyuda"
                    >
                      <option value="99">Seleccionar</option>
                      {regionesReposo.map((datos) => (
                        <option key={datos.codigo} value={datos.codigo}>
                          {datos.region}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {meta.error ? meta.error : ""}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Field>

              <Field name="ciudadReposo">
                {({ field, meta }) => (
                  <Form.Group className="mb-3 input-wrapper" controlId="ciudadReposo">
                    <Form.Label>Ciudad</Form.Label>
                    <Form.Control
                      {...field}
                      as="select"
                      className="form-control-lg"
                      value={field.value}
                      isInvalid={meta.error}
                      isValid={!meta.error}
                      onChange={(e) => {
                        field.onChange(e);
                        selectCiudadReposo(e, formik);
                      }}
                      aria-describedby="ciudadReposoAyuda"
                    >
                      <option value="99">Seleccionar</option>
                      {ciudadesReposo.map((datos) => (
                        <option
                          key={`${datos.codigo}-${datos.provincia}`}
                          value={`${datos.codigo}-${datos.provincia}`}
                        >
                          {datos.provincia}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {meta.error ? meta.error : ""}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Field>

              <Field name="comunaReposo">
                {({ field, meta }) => (
                  <Form.Group className="mb-3 input-wrapper" controlId="comunaReposo">
                    <Form.Label>Comuna</Form.Label>
                    <Form.Control
                      {...field}
                      as="select"
                      className="form-control-lg"
                      value={field.value}
                      isInvalid={meta.error}
                      isValid={!meta.error}
                      onChange={(e) => {
                        field.onChange(e);
                        selectComunaReposo(e, formik);
                      }}
                      aria-describedby="comunaReposoAyuda"
                    >
                      <option value="99">Seleccionar</option>
                      {comunasReposo.map((datos) => (
                        <option key={datos.codigo} value={datos.codigo}>
                          {datos.comuna}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {meta.error ? meta.error : ""}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Field>
            </>
          )}

          <Field name="prevision">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="prevision">
                <Form.Label>Previsión de salud</Form.Label>
                <Form.Control
                  {...field}
                  as="select"
                  className="form-control-lg"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="previsionAyuda"
                >
                  <option value="99">Seleccionar</option>
                  {previsiones.map((datos) => (
                    <option key={datos.codigo} value={datos.codigo}>
                      {datos.nombre}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : ""}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="nivelEducacional">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="nivelEducacional">
                <p className="mt-4 mb-2 fs-5 fw-bold border-bottom pb-2">
                  Nivel educacional
                </p>
                <Form.Label>Indique su situación actual</Form.Label>
                <Form.Control
                  {...field}
                  as="select"
                  className="form-control-lg"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="nivelEducacionalAyuda"
                >
                  <option value="99">Seleccionar</option>
                  {parametrosEducacion.map((datos) => (
                    <option key={datos.idNivAfi} value={datos.idNivAfi}>
                      {datos.descripcion}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : ""}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="profesion">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="profesion">
                <p className="mt-4 mb-2 fs-5 fw-bold border-bottom pb-2">
                  Profesión u oficio
                </p>
                <Form.Label>Indique su situación laboral actual</Form.Label>
                <Form.Control
                  {...field}
                  as="select"
                  className="form-control-lg"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="profesionAyuda"
                >
                  <option value="99">Seleccionar</option>
                  {parametrosOcupacion.map((datos) => (
                    <option key={datos.idProOfiAfi} value={datos.idProOfiAfi}>
                      {datos.descripcion}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : ""}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="antecedentesLaborales">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="antecedentesLaborales">
                <p className="mt-4 mb-2 fs-5 fw-bold border-bottom pb-2">
                  Antecedentes laborales
                </p>
                <Form.Label>Indique su situación laboral actual</Form.Label>
                <Form.Control
                  {...field}
                  as="select"
                  className="form-control-lg"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="antecedentesLaboralesAyuda"
                >
                  <option value="99">Seleccionar</option>
                  {condicionesLaborales.map((datos) => (
                    <option key={datos.idConAfi} value={datos.idConAfi}>
                      {datos.descripcion}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : ""}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          {formik.values.antecedentesLaborales === "2" && (formik.values.profesion === "2" || formik.values.profesion === "3") && (
            <Field name="fechaInicioDesempleoPrivado">
              {({ field, meta }) => (
                <Form.Group className="mb-3 input-wrapper" controlId="fechaInicioDesempleoPrivado">
                  <Form.Label>Fecha de inicio periodo de desempleo (Obligatorio)</Form.Label>
                  <Form.Control
                    {...field}
                    mask={fechaMask}
                    type="text"
                    className="form-control-lg"
                    name="fechaInicioDesempleoPrivado"
                    placeholder="dd/mm/yyyy"
                    autoComplete="off"
                    isInvalid={meta.error}
                    isValid={!meta.error}
                    aria-describedby="fechaInicioDesempleoPrivadoAyuda"
                  />
                  <Form.Control.Feedback type="invalid" id="fechaInicioDesempleoPrivadoAyuda" muted>
                    {meta.error ? meta.error : ""}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            </Field>
          )}

          {(formik.values.profesion === "4" || formik.values.profesion === "5") && (
            <Field name="fechaInicioDesempleoPublico">
              {({ field, meta }) => (
                <Form.Group className="mb-3 input-wrapper" controlId="fechaInicioDesempleoPublico">
                  <Form.Label>Fecha de cese de funciones</Form.Label>
                  <Form.Control
                    {...field}
                    mask={fechaMask}
                    type="text"
                    className="form-control-lg"
                    placeholder="dd/mm/yyyy"
                    autoComplete="off"
                    isInvalid={meta.error}
                    isValid={!meta.error}
                    aria-describedby="fechaInicioDesempleoPublicoAyuda"
                  />
                  <Form.Text id="fechaInicioDesempleoPublicoAyuda" type="invalid">
                    {meta.error ? meta.error : ""}
                  </Form.Text>
                </Form.Group>
              )}
            </Field>
          )}

          {formik.values.antecedentesLaborales === "3" && (
            <>
              <p className="mt-4 mb-2 fs-5 fw-bold border-bottom pb-2">
                Periodo Licencia Médica (opcional)
              </p>
              {/* Fecha inicio */}
              <Field name="fechaInicioLicenciaMedica">
                {({ field, meta }) => (
                  <Form.Group className="mb-3 input-wrapper" controlId="fechaInicioLicenciaMedica">
                    <Form.Label>Fecha de inicio Licencia Médica</Form.Label>
                    <Form.Control
                      {...field}
                      mask={fechaMask}
                      type="text"
                      className="form-control-lg"
                      placeholder="dd/mm/yyyy"
                      autoComplete="off"
                      isInvalid={meta.error}
                      isValid={!meta.error}
                      aria-describedby="fechaInicioLicenciaMedicaAyuda"
                    />
                    <Form.Control.Feedback type="invalid" id="fechaInicioLicenciaMedicaAyuda">
                      {meta.error ? meta.error : ""}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Field>

              {/* Fecha fin */}
              <Field name="fechaFinLicenciaMedica">
                {({ field, meta }) => (
                  <Form.Group className="mb-3 input-wrapper" controlId="fechaFinLicenciaMedica">
                    <Form.Label>Fecha de término Licencia Médica</Form.Label>
                    <Form.Control
                      {...field}
                      mask={fechaMask}
                      type="text"
                      className="form-control-lg"
                      placeholder="dd/mm/yyyy"
                      autoComplete="off"
                      isInvalid={meta.error}
                      isValid={!meta.error}
                      aria-describedby="fechaFinLicenciaMedicaAyuda"
                    />
                    <Form.Control.Feedback type="invalid" id="fechaFinLicenciaMedicaAyuda" >
                      {meta.touched && meta.error ? meta.error : ""}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Field>
            </>
          )}

          <Field name="afiliadoPensionado">
            {({ field, meta }) => (
              <Form.Group className="mb-3 input-wrapper" controlId="afiliadoPensionado">
                <p className="mt-4 mb-2 fs-5 fw-bold border-bottom pb-2">
                  ¿Qué tipo de afiliado o pensionado eres?
                </p>
                <Form.Label>Indique su tipo de afiliación actual</Form.Label>
                <Form.Control
                  {...field}
                  as="select"
                  className="form-control-lg"
                  isInvalid={meta.error}
                  isValid={!meta.error}
                  aria-describedby="profesionAyuda"
                >
                  <option value="99">Seleccionar</option>
                  {parametrosAfiliadoPensionado.map((datos) => (
                    <option value={datos.idTipAfiPen}>
                      {datos.descripcion}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {meta.error ? meta.error : ""}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Field>

          <Field name="radioCobertura">
            {({ field }) => (
              <Form.Group className="mb-3 input-wrapper">
                <Form.Label>¿Tiene cobertura del Seguro de Invalidez y Sobrevivencia?</Form.Label>
                <Stack direction="horizontal" gap={2}>
                  <Form.Check
                    {...field}
                    inline
                    label="Si"
                    type="radio"
                    name="radioCobertura"
                    id="inlineRadio1"
                    value="SI"
                    className=""
                  />
                  <Form.Check
                    {...field}
                    inline
                    label="No"
                    type="radio"
                    name="radioCobertura"
                    id="inlineRadio2"
                    value="NO"
                  />
                </Stack>
              </Form.Group>
            )}
          </Field>

          <Field name="Autoriza">
            {({ field }) => (
              <Form.Group className="mb-5 input-wrapper" controlId="Autoriza">
                <Form.Check
                  {...field}
                  type="checkbox"
                  name="Autoriza"
                  id="Autoriza"
                  label={
                    <strong data-tooltip-id="tooltipInfo">
                      Autorizo a la AFP para que suscriba a mi nombre la Solicitud de Aporte Previsional Solidario.
                    </strong>
                  }
                  defaultChecked
                />
              </Form.Group>
            )}
          </Field>

          <div className="justify-content-center">
            <div className="d-flex mb-2">
              <Button
                variant="success"
                className="col-md-12"
                type="button"
                disabled={!(formik.isValid && formik.dirty) || isLoading}
                onClick={(e) => {
                  handleSubmit(e, formik.values);
                }}
              >
                {isLoading ? <Spinner animation="border" variant="light" size="sm" /> : "Continuar"}
              </Button>
            </div>
            <div className="d-flex">
              <Button variant="link" className="col-md-12"
                onClick={() => {
                  history(-1);
                }}>
                Volver al paso anterior
              </Button>
            </div>
          </div>

          {/*<pre>{JSON.stringify(formik, null, 2)}</pre>*/}
        </Form>
      )}
    </Formik>
  );
};

export default FormDatosAfiliados;
